/* eslint-disable space-before-function-paren */
declare global {
  interface Array<T> {
    getDuplicatesByProperties(...properties: string[]): any[];
    includesDuplicatedValues(...values: any[]): boolean;
    copy(): T[];
    filterDistinct(): T[];
    insert(item: any, index: number): T[];
  }
}
Array.prototype.getDuplicatesByProperties = function (
  ...properties: any[]
): string[] {
  const reducedArray = this.map((item) =>
    properties.reduce((acc, prop) => {
      acc.push(
        typeof item[prop] === 'string'
          ? item[prop].trim().toLowerCase()
          : item[prop]
      );
      return acc;
    }, [])
  ).map((x) => JSON.stringify(x));
  const duplicates = [
    ...new Set(reducedArray.filter((e, i, a) => a.indexOf(e) !== i)),
  ];

  return duplicates;
};

/**
 * @description checks if received values appear in duplication array returned by 'getDuplicatesByProperties'
 * @param values entity property values to be checked
 */
Array.prototype.includesDuplicatedValues = function (
  ...values: any[]
): boolean {
  const lowerCasedValues = values.map((x) =>
    typeof x === 'string' ? x.trim().toLowerCase() : x
  );
  return this.includes(JSON.stringify(lowerCasedValues));
};

/**
 * @description copies the elements of one array into another one replacing items reference
 * @param array array to copy
 */
Array.prototype.copy = function <T>(): T[] {
  if (!this?.length) {
    return [];
  }

  return this.map((x) => ({ ...x }));
};

Array.prototype.filterDistinct = function <T>(): T[] {
  return this.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });
};

Array.prototype.insert = function <T>(item: any, index: number): T[] {
  return this.splice(index, 0, item);
};

export {};
